import { RemoteGetAllCancellationReasons } from 'data/usecases';
import { GetAllCancellationReasonsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCancellationReasons } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCancellationReasons =
  (): GetAllCancellationReasonsUseCaseInterface =>
    new RemoteGetAllCancellationReasons(
      makeApiUrlCancellationReasons(),
      makeAxiosHttpClient(),
    );
